import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import TripOptions from './components/TripOptions';

function App() {
  const updateRangeTrack = (slider) => {
    const min = parseFloat(slider.getAttribute('min'));
    const max = parseFloat(slider.getAttribute('max'));
    const value = parseFloat(slider.value);
    const percent = (value - min) / (max - min);
    
    slider.style.setProperty('--value', value);
    slider.style.setProperty('--percent', percent);
    
    // Update the track position
    const track = slider.parentElement;
    if (slider.classList.contains('min')) {
      track.style.setProperty('--min', percent);
    } else {
      track.style.setProperty('--max', percent);
    }
  };

  // Initialize CSS variables for range sliders
  useEffect(() => {
    const sliders = document.querySelectorAll('.time-range-slider input[type="range"]');
    sliders.forEach(slider => {
      const min = parseFloat(slider.getAttribute('min'));
      const max = parseFloat(slider.getAttribute('max'));
      const value = parseFloat(slider.value);
      const percent = (value - min) / (max - min);
      
      slider.style.setProperty('--value', value);
      slider.style.setProperty('--percent', percent);
      
      const track = slider.parentElement;
      if (slider.classList.contains('min')) {
        track.style.setProperty('--min', percent);
      } else {
        track.style.setProperty('--max', percent);
      }
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/trip-planner/Amsterdam/Berlin" />} />
        <Route path="/trip-planner" element={<Navigate to="/trip-planner/Amsterdam/Berlin" replace />} />
        <Route path="/trip-planner/:origin/:destination/:departure/:return" element={<TripOptions />} />
        <Route path="/trip-planner/:origin/:destination/:departure" element={<TripOptions />} />
        <Route path="/trip-planner/:origin/:destination" element={<TripOptions />} />
        <Route path="*" element={<div>Er ging iets mis bij het overnemen van de ingestelde parameters door de Trip Planner (404).</div>} />
      </Routes>
    </Router>
  );
}

export default App;
